import { render, staticRenderFns } from "./UpdateRevisionForm.vue?vue&type=template&id=1a12ba8e&"
import script from "./UpdateRevisionForm.vue?vue&type=script&lang=js&"
export * from "./UpdateRevisionForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports